<pm-dialog
  [visible]="isDialogOpen()"
  emoji="🍪"
  [closable]="false"
  [hideCancelButton]="true"
  i18n-confirmButtonLabel
  confirmButtonLabel="Akceptuję"
  styleClass="max-dialog-width"
  (saveEvent)="onSave()"
  [customActionsTemplate]="customActionsTemplate"
>
  <div class="title color-main font-semibold text-xl mb-3" i18n>
    Dbamy o Twoją prywatność
  </div>
  <div class="text mb-3" i18n>
    Używamy plików cookie, aby zapewnić najlepsze doświadczenia na naszej
    stronie. <br />
    Niektóre są niezbędne do działania serwisu, inne pomagają nam go ulepszać.
    <br />
    <pm-link [route]="CC_LINK" [external]="true">Dowiedz się więcej</pm-link>
  </div>

  <div
    class="cookies-form-container"
    [ngClass]="{ 'out-of-screen': !isCookiesSettingsFormVisible() }"
  >
    <pm-form
      [config]="config"
      #cookiesSettingsForm
      (submitEvent)="onFormSubmit($event)"
    >
    </pm-form>
  </div>

  <ng-template #customActionsTemplate>
    <pm-button
      i18n-label
      [label]="
        isCookiesSettingsFormVisible() ? 'Ukryj ustawinia' : 'Pokaż ustawienia'
      "
      class="ml-2-5 mr-2-5"
      (clickEvent)="openSettings()"
      [type]="PMButtonTypeEnum.SECONDARY"
    ></pm-button>
    <pm-button
      i18n-label
      label="Zapisz"
      (clickEvent)="onSave()"
      [type]="PMButtonTypeEnum.PRIMARY"
    ></pm-button>
  </ng-template>
</pm-dialog>
